import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ResetpasswordemailserviceService } from './resetpasswordemailservice.service';

@Component({
  selector: 'resetpasswordemail',
  templateUrl: './resetpasswordemail.component.html',
  styleUrls: ['./resetpasswordemail.component.scss']
})
export class ResetpasswordemailComponent implements OnInit {

  resetPasswordForm: FormGroup;
  isSubmitting = false;
  errorMessage = '';
  successMessage = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private resetPasswordService: ResetpasswordemailserviceService
  ) {
    this.resetPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  ngOnInit(): void {
    //  initialization
  }

  get email() {
    return this.resetPasswordForm.get('email');
  }

  get emailError(): string {
    if (this.email?.hasError('required')) {
      return 'Email address is required';
    }
    if (this.email?.hasError('email')) {
      return 'Please enter a valid email address';
    }
    return '';
  }

  onSubmit(): void {
    // Validate form
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      return;
    }

    // Reset messages
    this.isSubmitting = true;
    this.errorMessage = '';
    this.successMessage = '';

    const email = this.resetPasswordForm.value.email;

    // Call the API
    this.resetPasswordService.sendResetLink(email).subscribe({
      next: (response) => {
        this.isSubmitting = false;
        
        // Success response
        this.successMessage = response.message || 
          'A password reset link has been sent. Please check your email inbox or spam for link';
        
        // Reset form
        this.resetPasswordForm.reset();
        
        setTimeout(() => {
          // this.router.navigate(['/reset-password']);
        }, 5000);
      },
      error: (error) => {
        this.isSubmitting = false;
        
        // Handle different error scenarios
        if (error.status === 400) {
          this.errorMessage = error.error.message || 'Invalid email address. Please check and try again.';
        } else if (error.status === 500) {
          this.errorMessage = 'Server error. Please try again later or contact support.';
        } else if (error.status === 0) {
          this.errorMessage = 'Unable to connect to server. Please check your internet connection.';
        } else {
          this.errorMessage = error.error.message || 'An unexpected error occurred. Please try again.';
        }
        
        console.error('Password reset error:', error);
      }
    });
  }

  goBack(): void {
    this.router.navigate(['/login']);
  }

}